import React, { Fragment } from "react";
import { FormattedMessage } from 'react-intl';
import { Field } from "formik";
import {
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import Select2 from "react-select2-wrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as fontAwesome from "@fortawesome/free-solid-svg-icons";
import { Messages } from '../layout/Messages/Messages';
import { ErrorMessage } from 'formik';

function OrganizationSelect(props) {
  const { organizations } = props;
  const fieldName = props.fieldName || props.name || 'organization';
  const errorClass = props.getErrorClass( props.formikProps, fieldName ) || '';

  let formattedOrganizations = organizations.map( item => {
    return { id: item.id, text: item.name }
  } );

  return (
    <FormGroup>
      <InputGroup
        className={`input-group-merge input-group-alternative select-addon select-${fieldName} ${errorClass}`.trim()}>
        <FormattedMessage id={props.label}>
          {
            placeholder => (
              <Field>
                {
                  () => (
                    <Fragment>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          {
                            props.fontAwesome ?
                              <FontAwesomeIcon
                                icon={fontAwesome[props.fontAwesome]}/> :
                              <i className={props.icon}/>
                          }
                        </InputGroupText>
                      </InputGroupAddon>
                      <Select2
                        id={'input-' + props.name}
                        name={props.name}
                        defaultValue={props.value}
                        placeholder={placeholder[0]}
                        className='form-control'
                        options={{
                          placeholder: placeholder[0]
                        }}
                        data={formattedOrganizations}
                        onChange={
                          event => {
                            if (props.onChange) {
                              props.onChange( event );
                            }
                          }
                        }
                      />
                    </Fragment>
                  )
                }
              </Field>
            )
          }
        </FormattedMessage>
      </InputGroup>
      <Messages
        color="danger"
        formikProps={props.formikProps}
        class="small-field-error"
        showDismiss={false}
      >
        <ErrorMessage
          name={fieldName}
          component="div"
          data-testid={`errors-${fieldName}`}
          className="field-error"
        />
      </Messages>
    </FormGroup>
  );
}

OrganizationSelect.defaultProps = {
  name: 'organization',
  organizations: [],
  getErrorClass: () => '',
};

export { OrganizationSelect };
